import lottie from "lottie-web";
import { useEffect, useRef, useState } from "react";

import animation from "@/assets/logo.json";
import useTestMobile from "@/hooks/useTestMobile";

const Logo = ({ className }: { className?: string }) => {
  // Test for mobile
  const isMobile = useTestMobile();

  // Handle animation
  const anim = useRef(null);
  const [isReady, setIsReady] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    anim.current = lottie.loadAnimation({
      name: "logo",
      container: containerRef.current,
      renderer: "svg",
      loop: false,
      autoplay: false,
      animationData: animation,
    });
    const onReady = () => {
      setIsReady(true);
    };
    anim.current.addEventListener("DOMLoaded", onReady);
    // Cleanup
    return () => {
      if (!anim.current) return;
      anim.current.removeEventListener("DOMLoaded", onReady);
      anim.current.destroy();
    };
  }, []);

  // Animate logo on hover
  useEffect(() => {
    // No point in hovering for mobile
    if (isMobile) return undefined;

    if (!anim.current || !isReady) return undefined;
    const { current: hoverTrigger } = containerRef;

    const onMouseEnter = () => {
      anim.current.setDirection(1);
      anim.current.play();
    };

    const onMouseLeave = () => {
      anim.current.setDirection(-1);
      anim.current.play();
    };

    hoverTrigger.addEventListener("mouseenter", onMouseEnter, true);
    hoverTrigger.addEventListener("mouseleave", onMouseLeave, true);

    return () => {
      hoverTrigger.removeEventListener("mouseenter", onMouseEnter, true);
      hoverTrigger.removeEventListener("mouseleave", onMouseLeave, true);
    };
  }, [isReady, isMobile]);

  return <div className={className} ref={containerRef} />;
};

export default Logo;
